import { usePointsExperienceListing } from "../../context/PointsExperienceListingContext";
import { POINTS_EXCHANGE_TYPE_VALUES } from "../../constants";
import ExchangePoints from "../ExchangePoints/ExchangePoints";
import BuyPoints from "../BuyPoints/BuyPoints";

export default function PointsExperienceListingOutlet() {
  const { selectedType } = usePointsExperienceListing();
  if (selectedType === POINTS_EXCHANGE_TYPE_VALUES.EXCHANGE) return <ExchangePoints />;
  if (selectedType === POINTS_EXCHANGE_TYPE_VALUES.BUY) return <BuyPoints />;
}
